import $http from '@/resource';
import utils from '@/utils';

const $api = {};

/**
 * 获取行政区划|所属区域|项目来源|专业类别数据
 *
 * @author zyz 2020-7-3 14:34:56
 *
 * @method GET
 *
 * @param {String} type 类型1所属区域管理2项目来源管理3专业类别管理4行政区划管理
 * @param {String} status 查询类型0为未删除的，1为所有
 *
 * @url company/division
 *
 * @return {Promise<void>}
 */
$api.getCompanyConfig = async (type,status="0")=>{
    const url = `company/division?type=${type}&status=${status}`;
    return await $http.get(url);
};

/**
 * 保存行政区划|所属区域|项目来源|专业类别数据
 *
 * @author zyz 2020-7-7 10:29:46
 *
 * @method POST
 *
 * @param {String} type 分类
 * @param {Object} data 待提交的数据
 *
 * @url company/division
 *
 * @return {Promise<*>}
 */
$api.saveCompanyConfig = async (type,data)=>{
    const url = `company/division`;
    return await $http.post(url,{"type":type,"data":data});
};

/**
 * 删除行政区划|所属区域|项目来源|专业类别数据
 *
 * @author zyz 2020-7-7 13:34:58
 *
 * @method delete
 *
 * @param {String} type 分类
 * @param {String} id 待删除项的id
 *
 * @url company/division
 *
 * @return {Promise<void>}
 */
$api.deleteCompanyConfig = async (type,id)=>{
    const url = `company/division/${id}?type=${type}`;
    return await $http.delete(url);
};

/**
 * 企业区域管理列表保存
 * @author zyz 2020-11-6 09:37:45
 * @method patch
 * @param {Object} data 待提交的数据
 * @url
 * @returns {Promise<void>}
 */
$api.saveCompanyAreaList = async(data) => {
    const url = `areas/save`;
    return await $http.post(url,data);
};

/**
 * 获取企业区域管理列表
 * @author zyz 2020-11-6 09:47:49
 * @method get
 * @param {Object} data 搜索条件
 * @url
 * @returns {Promise<void>}
 */
$api.getCompanyArea = async(data) => {
    const url = `areas/list?keyword=${data.keyword}&page=${data.page}&pageSize=${data.pageSize}`;
    return await $http.get(url);
};

/**
 * 上传保存企业区域管理列表
 * @author zyz 2020-11-6 10:49:41
 * @method post
 * @param {String} id 文件id
 * @returns {Promise<void>}
 */
$api.uploadCompanyArea = async(id) => {
    const url = `areas/file`;
    return await $http.post(url,{'id':id});
};

/**
 * 保存企业区域添加的数据
 * @author zyz 2020-11-6 11:39:15
 * @method post
 * @param {Array} data 待添加的数据
 * @url areas/add
 * @returns {Promise<void>}
 */
$api.saveCompanyAreaAdd = async(data) =>{
    const url =`areas/add`;
    return await $http.post(url,data);
};

export default $api;


// WEBPACK FOOTER //
// ./src/service/company/settingCommon.js